import styled from 'styled-components';
import { phoneFrameSizes } from '@components/PhoneFrame/PhoneFrame';
import { largeLayout } from '@styles/layout';

const phoneWidth = largeLayout.getSize(4);
export const phoneScale = phoneWidth / phoneFrameSizes.width;

export const Wrapper = styled.div`
`;

export const StickyContent = styled.div`
  position: fixed;
  width: ${phoneFrameSizes.width * phoneScale}px;
  height: ${phoneFrameSizes.height * phoneScale}px;
  top: 0;
  left: 50%;
  transform-origin: top left;
`;


// WEBPACK FOOTER //
// src/app/src/components/StickyPhone/StickyPhone.s.ts